<template>
  <div>
    <div class="btn-group view-mode page-filter" role="group">
      <button
        class="btn btn-default"
        :class="{ 'btn-active': localPage === 'find'}"
        type="button"
        @click="gotoPage('find')"
      >
        <span class="glyphicon glyphicon-search"></span>
        {{ $t(`main.SEARCH_PROPERTY_S`)}}
      </button>
      <button
        class="btn btn-default"
        :class="{ 'btn-active': localPage === 'transaction'}"
        type="button"
        @click="gotoPage('transaction')"
      >
        <span class="glyphicon glyphicon-search"></span>
        {{ $t(`main.TX`)}}
      </button>
      <button
        class="btn btn-default"
        :class="{ 'btn-active': localPage === 'agent'}"
        type="button"
        @click="gotoPage('agent')"
      >
        <span class="glyphicon glyphicon-search"></span>
        {{ $t(`main.DRAWER_AGENT`)}}
      </button>
    </div>
  </div>
</template>

<script>
import uriParamsMixin from '@/mixins/uriParams';

export default {
  mixins: [ uriParamsMixin ],
  props: {
    page: {
      default: () => 'find',
    },
    keyword: {
      type: String,
    },
    txType: {
      type: Array,
    },
    districts: {
      type: Array,
    },
    advanceSearch: {},
    filterParams: {},
  },
  data () {
    return {
      localPage: '',
    }
  },  
  mounted() {
    this.localPage = this.page;
  },
  computed: {
    paramOptions() {
      let p =  [
        { key: 'icsType', option: 'industrial', value: 'i' },
        { key: 'icsType', option: 'office', value: 'c' },
        { key: 'icsType', option: 'shops', value: 's' },        
      ];

      if (this.localPage === 'transaction') {
        p.push(
          { key: 'txType', option: 'sold', value: ['S'] },
          { key: 'txType', option: 'leased', value: ['L'] },
          { key: 'txType', option: 'both', value: ['B'] },
        );
      } else if (this.localPage === 'find') {
        p.push(
          { key: 'txType', option: 'sale', value: ['S'] },
          { key: 'txType', option: 'lease', value: ['L'] },
          { key: 'txType', option: 'both', value: ['B'] },
        );
      }      
      return p;
    },
  },
  methods: {
    gotoPage(value) {
      const fromPage = this.page;
      this.localPage = value;
      let freetext = null;
      if (this.keyword) {
        freetext = {
          "suggestionWord": this.keyword,
          "type": "free_text",
          "value": this.keyword,
          "ics": "",
        };
        freetext = JSON.stringify(freetext);
      }      
      const filters = this.uriToFilters(this.$route.query, this.$route.params);

      if (this.advanceSearch) {
        filters.advanceSearch = this.advanceSearch;
      }

      if (filters.keywords) {
        const tmpKeywords = decodeURIComponent(filters.keywords);
        const matchedKeywords = tmpKeywords.match(/(\{.*?\},?)/g);

        if (this.localPage === 'transaction') {
          const regex = /"addr"/g;
          filters.keywords = filters.keywords.replaceAll(regex, '"street"');

          if (fromPage === 'find') {
            matchedKeywords.forEach(k => {
              if (k.includes('stockID') || k.includes('emp')) {
                // remove stock ids and agent keywords
                filters.keywords = filters.keywords.replaceAll(k, '');
              }
            });
          }

          if (fromPage === 'agent') {
            matchedKeywords.forEach(k => {
              // remove all keywords
              filters.keywords = filters.keywords.replaceAll(k, '');
            });
          }
        }

        if (this.localPage === 'find') {
          const regex = /"street"/g;
          filters.keywords = filters.keywords.replaceAll(regex, '"addr"'); 

          if (fromPage === 'agent') {
            matchedKeywords.forEach(k => {
              if (k.includes('free_text')) {
                // remove all free text keyword like phone number or licence
                filters.keywords = filters.keywords.replaceAll(k, '');
              }
            });
          }
        }

        if (this.localPage === 'agent') {
          if (fromPage === 'find') {
            matchedKeywords.forEach(k => {
              if (k.includes('stockID') || k.includes('building') 
                || k.includes('street') || k.includes('addr')) {
                // remove stock ids, building and street keywords
                filters.keywords = filters.keywords.replaceAll(k, '');
              }
            });
          }

          if (fromPage === 'transaction') {
            matchedKeywords.forEach(k => {
              if (k.includes('addr') || k.includes('building') || k.includes('street')) {
                // remove building and street keywords
                filters.keywords = filters.keywords.replaceAll(k, '');
              }
            });
          }
        }

        if (freetext) {
          filters.keywords = `${filters.keywords},${freetext}`;
        }
        
      } else {
        filters.keywords = freetext;
      }

      if (this.localPage !== 'transaction') {
        filters.dateMin = null;
        filters.dateMax = null;
      }

      if (this.districts) {
        filters.districts = this.districts;
      }
      if (this.txType) {
        filters.txType = this.txType;
      }

      if (this.advanceSearch) {
        filters.advanceSearch = 1;
      } else {
        filters.advanceSearch = 0;
      }

      let uri = this.filtersToUri(filters, false);
      if (this.filterParams) {
        uri = this.filterParams;
        let resultUrl = this.absoluteUrl(this.localPage, uri);
        if (this.localPage === 'transaction') {
          const sale = /sale/g;
          resultUrl = resultUrl.replaceAll(sale, 'sold');
          const lease = /lease/g;
          resultUrl = resultUrl.replaceAll(lease, 'leased');
        }
        if (this.localPage === 'agent') {
          const sale = /\/sale/g;
          resultUrl = resultUrl.replaceAll(sale, '');
          const lease = /\/lease/g;
          resultUrl = resultUrl.replaceAll(lease, '');
        }
        window.location.href = resultUrl;
      } else {
        window.location.href = this.absoluteUrl(this.localPage, uri);
      }
      
    },
  },
};
</script>

<style scoped>
.page-filter {
  display: inline-flex;
  width: 100%;
}

.page-filter .btn.btn-default {
  background: #494949;
  color: #fff;
  outline: none;
  border: 0;
}

.page-filter .btn.btn-default + .btn.btn-default {
  border-left: 1px solid #999;
}

.page-filter .btn.btn-default.btn-active {
  background: #ffff00;
  color: #000;
  outline: none;
  border: 0;
}
.btn:hover,
.btn.active:hover {
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
.page-filter .btn {
  padding: 6px 16px;
  border: none;
  font-size: 18px;
  font-weight: 600;
  flex: 1 1 auto;
}
</style>